export enum CookieNameEnum {
    /** Merchant resumido. */
    MerchantSummary = 'merchant-summary',
    /** Token de acesso da aplicação. */
    AppAccessToken = 'app-access-token',
    /** Tempo de expiração do token da aplicação em segundos. */
    AppAccessTokenExpiration = 'app-access-token-expiration',
    /** Tokens de acesso do usuário logado. */
    UserAccessTokens = 'user-access-tokens',
    /** Caso não estiver logado e for redirecionado para `/entrar` após tentar acessar uma rota que necessita de autorização, após o login redireciona para esta URL do cookie. */
    CallbackUrl = 'callback-url',
    /** Cartões de crédito do usuário. */
    CustomerCards = 'customer-cards',
    /** Domínio (subdomínio) da aplicação. */
    Domain = 'domain',
    /** Flag para mostrar o popup. */
    PwaPopup = 'pwa-popup',
    /** ID de notificações push do app Xamarin. */
    IdPushNotification = 'IdPushNotification',
    /** Verifica se está dentro do aplicativo IOS ou Android */
    IsAppAndroidOrIOS = 'isAppAndroidOrIOS',
    /* Versão do app. */
    AppVersion = 'version'
}

/** Cookies utilizados apenas para realizar a autenticação do usuário na rota auth. */
export enum CookiesSocialLogin {
    TempAppAccessToken = 'temp-app-config',
    SocialUser = 'social-user',
    MerchantData = 'merchant-data',
}